import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["rows", "value"]
const _hoisted_4 = { class: "absolute right-0 -top-5" }
const _hoisted_5 = {
  class: "text-sm",
  style: {"font-weight":"400","font-size":"11px"}
}
const _hoisted_6 = {
  key: 0,
  class: "relative z-10 flex w-full hide-in-thumbnail"
}
const _hoisted_7 = {
  key: 0,
  style: {"font-size":"12px"},
  class: "ml-auto text-sm text-muted"
}
const _hoisted_8 = {
  class: "text-sm",
  style: {"font-weight":"400","font-size":"11px"}
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "text-sm font-light text-danger-dark"
}
const _hoisted_11 = ["id"]
const _hoisted_12 = {
  style: {"width":"16px !important"},
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", {
  class: "ql-stroke",
  style: {"stroke-width":"0.5 !important","fill":"unset","stroke":"#444"},
  d: "M12.42,5.29C11.32,5.19 10.35,6 10.25,7.11L10,10H12.82V12H9.82L9.38,17.07C9.18,19.27 7.24,20.9 5.04,20.7C3.79,20.59 2.66,19.9 2,18.83L3.5,17.33C3.83,18.38 4.96,18.97 6,18.63C6.78,18.39 7.33,17.7 7.4,16.89L7.82,12H4.82V10H8L8.27,6.93C8.46,4.73 10.39,3.1 12.6,3.28C13.86,3.39 15,4.09 15.66,5.17L14.16,6.67C13.91,5.9 13.23,5.36 12.42,5.29M22,13.65L20.59,12.24L17.76,15.07L14.93,12.24L13.5,13.65L16.35,16.5L13.5,19.31L14.93,20.72L17.76,17.89L20.59,20.72L22,19.31L19.17,16.5L22,13.65Z"
}, null, -1)
const _hoisted_14 = ["id"]
const _hoisted_15 = {
  xmlns: "http://www.w3.org/2000/svg",
  "enable-background": "new 0 0 24 24",
  height: "35px",
  viewBox: "0 0 24 24",
  width: "35px",
  style: {"fill":"currentColor","margin-bottom":"-2px","margin-left":"-10px","transform":"scale(1.25)"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("rect", {
    fill: "none",
    height: "35",
    width: "35"
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "ql-stroke",
    style: {"stroke-width":"0.25 !important","fill":"unset","stroke":"#444"},
    d: "M3.5,9H5v6H3.5v-2.5h-2V15H0V9h1.5v2h2V9z M17.5,9H13c-0.55,0-1,0.45-1,1v5h1.5v-4.5h1V14H16v-3.51h1V15h1.5v-5 C18.5,9.45,18.05,9,17.5,9z M11,9H6v1.5h1.75V15h1.5v-4.5H11V9z M24,15v-1.5h-2.5V9H20v6H24z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'h-full': _ctx.tall }, "ql-container-element"]),
    id: _ctx.id
  }, [
    _createElementVNode("div", {
      onMouseup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.endDragging())),
      class: "relative flex space-x-2"
    }, [
      _createElementVNode("div", {
        id: _ctx.resizablePanelId,
        style: _normalizeStyle(_ctx.previewPanelStyle),
        class: _normalizeClass(["relative z-10 h-full rounded-t-sm light-input darken-on-hover bg-light", { 'opacity-80': _ctx.disabled, 'w-full': !_ctx.showPreview }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["z-10 h-full tex2jax_ignore ql-editor-container", [_ctx.$slots.errors?.() ? 'ql-editor-container-error' : '']])
        }, [
          (!_ctx.showBaseEditor && !_ctx.forceBaseEditor)
            ? (_openBlock(), _createBlock(_component_quill_editor, {
                key: 0,
                options: _ctx.editorOptions,
                value: _ctx.modelValue,
                disabled: _ctx.disabled || _ctx.internalDisabled,
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEditorChange($event))),
                onReady: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onEditorReady($event)))
              }, null, 8, ["options", "value", "disabled"]))
            : (_openBlock(), _createElementBlock("textarea", {
                key: 1,
                class: _normalizeClass(
							'py-3.5 px-3.5 bg-transparent rounded-t-sm outline-none' +
							(_ctx.baseEditorResizable ? ' resize-y' : ' resize-none')
						),
                rows: _ctx.baseEditorRows,
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
                value: _ctx.modelValue
              }, null, 42, _hoisted_3))
        ], 2),
        _createElementVNode("label", {
          class: _normalizeClass(["absolute -z-1 top-2 left-2 origin-0 ql-floating-label", { 'fixed-label': _ctx.modelValue?.length > 0 }])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createVNode(_component_Btn, {
            size: 'xs',
            variant: 'primary-borderless',
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPreview = !_ctx.showPreview))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.showPreview ? _ctx.$t("misc.hide_preview") : _ctx.$t("misc.show_preview")), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.containsLatex]
          ])
        ]),
        (!_ctx.forceBaseEditor)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.showBaseEditor)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("misc.using_base_editor")), 1))
                : _createCommentVNode("", true),
              (_ctx.showBaseEditor)
                ? (_openBlock(), _createBlock(_component_Btn, {
                    key: 1,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleBaseEditor())),
                    size: 'xs',
                    class: "ml-2",
                    variant: 'primary-borderless'
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("misc.show_full_editor")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 14, _hoisted_2),
      (_ctx.showPreview)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle([_ctx.dividerStyle, {"width":"5px","transition-property":"background"}]),
            onMousedown: _cache[5] || (_cache[5] = ($event: any) => (_ctx.startDragging())),
            class: "absolute top-0 z-30 h-full duration-150 delay-75 bg-gray-300 bg-opacity-50 resizer hover:bg-opacity-70"
          }, null, 36))
        : _createCommentVNode("", true),
      (_ctx.showPreview)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            onMousedown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.startDragging())),
            style: _normalizeStyle({
					..._ctx.dividerStyle,
					transform: 'translate(-40%, -50%) rotate(90deg)',
					'font-size': '20px !important',
				}),
            class: "absolute z-30 opacity-30 resizer top-1/2 material-icons-outlined"
          }, " drag_handle ", 36))
        : _createCommentVNode("", true),
      (_ctx.showPreview)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "relative px-8 py-2",
            style: _normalizeStyle({ width: 100 - _ctx.previewPanelWidth + '%' })
          }, [
            _createElementVNode("div", {
              style: {"white-space":"break-spaces"},
              class: "w-full",
              innerHTML: _ctx.stripHtmlFromLaTexBlocks(_ctx.modelValue)
            }, null, 8, _hoisted_9)
          ], 4))
        : _createCommentVNode("", true)
    ], 32),
    (_ctx.$slots.errors?.())
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _renderSlot(_ctx.$slots, "errors")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "hidden",
      id: _ctx.id + 'latex-button-src'
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_12, [
        _createElementVNode("title", null, _toDisplayString(_ctx.$t("misc.insert_latex")), 1),
        _hoisted_13
      ]))
    ], 8, _hoisted_11),
    _createElementVNode("div", {
      class: "hidden",
      id: _ctx.id + 'html-button-src'
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_15, [
        _createElementVNode("title", null, _toDisplayString(_ctx.$t("misc.show_base_editor")), 1),
        _hoisted_16,
        _hoisted_17
      ]))
    ], 8, _hoisted_14)
  ], 10, _hoisted_1))
}